<template>
  <div class="welcome-box" v-loading="divLoading">
    <div id="left" class="left" v-show="echartsShow"></div>
    <div id="welcome" class="welcome" v-show="!echartsShow">欢迎登录{{ appName }}</div>
    <!-- <div id="right" class="right"></div> -->
  </div>
</template>

<script>
// import * as echarts from 'echarts';
// import { getOrderGoodsDataChartList } from "@/api/system/projectWhite/projectWhite";

export default {
  data() {
    return {
      appName:process.env.VUE_APP_NAME,
      myLeftChart: null, // 将 myLeftChart 定义为组件的数据属性
      rawData: [],   // 存储从后端获取的数据
      dateList: [],  // 存储日期列表
      typeList: [],   // 存储类型列表
      divLoading: false,
      echartsShow: true,
      businessType: this.$store.getters.businessType,
    };
  },
  mounted() {
    // this.initChart();
    // this.$nextTick(() => {
    //   if(this.myLeftChart){
    //     this.myLeftChart.resize();
    //   }
    // });
    // this.fetchData();
  },
  computed: {
    project() {
      return this.$store.getters.project;
    }
  },
  // watch: {
  //   // echartsShow(newVal) {
  //   //   if (newVal && this.myLeftChart) {
  //   //     this.$nextTick(() => {
  //   //       this.myLeftChart.resize();
  //   //     });
  //   //   }
  //   // },
  //   // '$store.getters.project': {
  //   //   async handler(newVal, oldVal) {
  //   //     if(newVal.id === '202412171710046502850431363684237312' || newVal.id === '20241231152550812855478563304898560'){
  //   //       if(this.businessType === '9'){
  //   //         this.echartsShow = false
  //   //       } else {
  //   //         this.echartsShow = true
  //   //         await this.fetchData()
  //   //         if(this.myLeftChart){
  //   //           this.myLeftChart.resize(); // 切换项目后重新调整图表大小
  //   //         } else {
  //   //           this.initChart();
  //   //         }
  //   //       }
  //   //     }else{
  //   //       this.echartsShow = false
  //   //     }
  //   //   },
  //   //   immediate: true
  //   }
  // },
  methods: {


  }
};
</script>

<style lang="scss" scoped>
.welcome-box {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;

  .welcome{
    position: absolute;
    top: 50%;
    left:50%;
    margin-top: -14px;
    margin-left: -100px;
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
}
.left, .right {
  flex: 1; /* 子元素将平均分配父容器的空间 */
  width: 100%;
  height: 100%;
}
</style>